import { ApiError, type ApiErrorResponse } from "@modules/global/ApiError"

export type TagsSuccessResponse = {
    messageId: string
    message: string
}

type TagsListSuccessResponse = {
    messageId: string
    message: string
    entries: TagData[]
}

export type TagData = {
    tagId: number
    userId: number
    tagSlug: string
    tagName: string
    advertIds: number[]
}

export const fetchTagsFromApi = async (userId: number): Promise<TagData[]> => {
    return fetch(`/api/bookmarks/${userId}/tags/list`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        credentials: "same-origin",
    }).then(async (apiResponse: Response): Promise<TagData[]> => {
        if (!apiResponse.ok) {
            throw new ApiError((await apiResponse.json()) as ApiErrorResponse)
        }

        return (await ((await apiResponse.json()) as Promise<TagsListSuccessResponse>)).entries
    })
}

export const addTagForUser = async (userId: number, tagName: string, tagSlug: string): Promise<TagsSuccessResponse> => {
    return fetch(`/api/bookmarks/${userId}/tags/add`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({
            tagSlug,
            tagName,
        }),
    }).then(async (apiResponse: Response): Promise<TagsSuccessResponse> => {
        if (!apiResponse.ok) {
            throw new ApiError((await apiResponse.json()) as ApiErrorResponse)
        }

        return await ((await apiResponse.json()) as Promise<TagsSuccessResponse>)
    })
}

export const renameTagForUser = async (
    userId: number,
    oldTagSlug: string,
    tagName: string,
    tagSlug: string,
): Promise<TagsSuccessResponse> => {
    return fetch(`/api/bookmarks/${userId}/tags/rename`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({
            oldTagSlug,
            tagSlug,
            tagName,
        }),
    }).then(async (apiResponse: Response): Promise<TagsSuccessResponse> => {
        if (!apiResponse.ok) {
            throw new ApiError((await apiResponse.json()) as ApiErrorResponse)
        }

        return await ((await apiResponse.json()) as Promise<TagsSuccessResponse>)
    })
}

export const deleteTagOfUser = async (userId: number, tagSlug: string): Promise<TagsSuccessResponse> => {
    return fetch(`/api/bookmarks/${userId}/tags/delete`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({
            tagSlug,
            confirm: true,
        }),
    }).then(async (apiResponse: Response): Promise<TagsSuccessResponse> => {
        if (!apiResponse.ok) {
            throw new ApiError((await apiResponse.json()) as ApiErrorResponse)
        }

        return await ((await apiResponse.json()) as Promise<TagsSuccessResponse>)
    })
}

export const applyTagToUserEntry = async (
    userId: number,
    advertId: number,
    tagSlug: string,
): Promise<TagsSuccessResponse> => {
    return fetch(`/api/bookmarks/${userId}/tags/apply`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({
            advertId,
            tagSlug,
        }),
    }).then(async (apiResponse: Response): Promise<TagsSuccessResponse> => {
        if (!apiResponse.ok) {
            throw new ApiError((await apiResponse.json()) as ApiErrorResponse)
        }

        return await ((await apiResponse.json()) as Promise<TagsSuccessResponse>)
    })
}

export const removeTagFromUserEntry = async (
    userId: number,
    advertId: number,
    tagSlug: string,
): Promise<TagsSuccessResponse> => {
    return fetch(`/api/bookmarks/${userId}/tags/remove`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({
            advertId,
            tagSlug,
        }),
    }).then(async (apiResponse: Response): Promise<TagsSuccessResponse> => {
        if (!apiResponse.ok) {
            throw new ApiError((await apiResponse.json()) as ApiErrorResponse)
        }

        return await ((await apiResponse.json()) as Promise<TagsSuccessResponse>)
    })
}
